import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressCard } from '@fortawesome/free-solid-svg-icons';

const step3Str = "Your ID will be verified in a few minutes.\nYou will receive an email once verified.\nWe will reach out if we need anything else.";

export default function StepThree(props) {
  
    let yellowColor = props.yellowColor;
  
    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <FontAwesomeIcon icon={faAddressCard} style={{ color: yellowColor, fontSize: 30, marginTop: 30 }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        margin: 30 }}>
            <div style={{ fontSize: 18, fontFamily: 'OpenSans-SemiBold', color: yellowColor }}>
                DOCUMENTS UPLOADED
            </div>
            <div style={{ fontSize: 14, fontFamily: 'OpenSans-Regular', color: yellowColor, marginTop: 12, whiteSpace: 'break-spaces', textAlign: 'center' }}>
                {step3Str}
            </div>
            <div style={{ fontSize: 16, fontFamily: 'OpenSans-SemiBold', color: yellowColor, marginTop: 40 }}>
                THANK YOU
            </div>
        </div>
      </div>
    );
}